import React, { useState, useEffect } from "react";
import { TextField, Box, Chip } from "@mui/material";
import Slider from "../slider";

import StyledSlide from "./style";

const ChipTextInput = ({
  inputProps,
  onChange,
  name,
  onBlur,
  onFocus,
  noSpaces,
}) => {
  const [input, setInput] = useState([]);
  const [currentText, setCurrentText] = useState("");

  const addItemToArr = (text) => {
    const processedText = (text || "").toLowerCase();

    if (!processedText.replaceAll(" ", "")) return;

    setInput((arr) => {
      if (!arr.includes(processedText)) {
        return [...arr, processedText];
      } else {
        return arr;
      }
    });
    setCurrentText("");
  };

  const deleteInputElem = (elem) => {
    const index = input.indexOf(elem);

    if (index !== -1) {
      setInput((arr) => {
        const newArr = [...arr];
        newArr.pop(index);
        return newArr;
      });
    }
  };

  const onChangeHandler = (event) => {
    event.preventDefault();

    let text = String(event.target.value);

    if (text.slice(-1) === " " && noSpaces) {
      text = text.replaceAll(" ", "");
      addItemToArr(text);
    } else {
      setCurrentText(text);
    }
  };

  const onBlurHandler = (event) => {
    const text = event.target.value;

    addItemToArr(text);

    if (onBlur) {
      onBlur();
    }
  };

  const onDeleteHandler = (item) => {
    deleteInputElem(item);
  };

  const onKeyDownHandler = (key) => {
    if (key.code === "Enter") {
      addItemToArr(currentText);
    }
  };

  useEffect(() => {
    if (onChange) onChange({ data: input, name: name });
  }, [input]);

  return (
    <Box sx={{ width: "100%" }}>
      <TextField
        {...inputProps}
        fullWidth
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        value={currentText}
        onKeyDown={onKeyDownHandler}
        onFocus={onFocus}
      />

      <StyledSlide>
        <Slider>
          {input.map((item, i) => {
            return (
              <Chip
                label={item}
                onDelete={() => onDeleteHandler(item)}
                key={`chip-${i}`}
              />
            );
          })}
        </Slider>
      </StyledSlide>
    </Box>
  );
};

export default ChipTextInput;
